import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { throwError } from 'rxjs';
import { catchError, finalize, takeUntil } from 'rxjs/operators';
import { ComponentBase } from '../../helpers/ComponentBase';
import { IPopoverItemParams } from '../../model/popover/IPopoverItemParams';

@Component({
	selector: 'osapp-popover',
	templateUrl: './popover.component.html',
	styleUrls: ['./popover.component.scss']
})
export class PopoverComponent extends ComponentBase implements OnInit, OnDestroy {

	//#region PROPERTIES

	/** Tableau des paramètres pour les items du composant à montrer. */
	@Input() public items: IPopoverItemParams[];
	/** Identifiant du composant pour fermer sa popover et pas une autre. */
	@Input() public componentId: string;

	//#endregion

	//#region METHODS

	constructor(protected ioPopoverCtrl: PopoverController, poChangeDetectorRef?: ChangeDetectorRef) {
		super(poChangeDetectorRef);
	}

	public ngOnInit(): void {
		if (!this.items)
			this.items = [];
	}

	public ngOnDestroy(): void {
		this.close()
			.then(_ => super.ngOnDestroy());
	}

	/** Ferme la popover. */
	public close(): Promise<boolean> {
		return this.ioPopoverCtrl.getTop()
			.then((poPopover: HTMLIonPopoverElement) => poPopover ? this.ioPopoverCtrl.dismiss(undefined, undefined, this.componentId) : false);
	}

	/** Exécute l'action associée à l'objet passé en paramètre.
	 * @param poItem Item dont on veut exécuter l'action.
	 */
	public execute(poItem: IPopoverItemParams): void {
		poItem.action()
			.pipe(
				catchError(poError => { console.error("POPOV.C:: Erreur lors de l'exécution de l'action de l'item", poItem, " :", poError); return throwError(poError); }),
				finalize(() => this.close()),
				takeUntil(this.destroyed$)
			)
			.subscribe();
	}

	//#endregion
}